import styled from 'styled-components';
import { Section } from './Layout';

export const HowItWorksSection = styled(Section)`
  text-align: center;
`;

export const StepContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StepNumber = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #0066ff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 20px;
`; 